import React, { useEffect, useState } from "react";
import { HomeContextImport } from "../../../provider/home/HomeContextProvider";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import Div from "../../../widget/common/ui/Div";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import BranchLogoName from "../../../widget/screens/home/BranchLogoName";
import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import BranchFollowGroupsList from "./widget/BranchFollowGroupsList";
import { BranchFollowGroupsContextImport } from "../../../provider/branch/branch_follow_groups/BranchFollowGroupsContextProvider";
import { FollowGroupsList } from "../../../model/branch/BranchFollowGroupsListModel";
import SearchInput from "../../../widget/common/form/SearchInput";
import CacheStorage from "../../../service/storage/CacheStorage";

const BranchFollowGroupContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;
  return <BranchFollowGroupMainContent type={type} isModal={isModal} />;
};

export default BranchFollowGroupContent;

const BranchFollowGroupMainContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  const { getBranchDetail, branchDetail } = HomeContextImport();
  const {
    getGroupsListAPI,
    groupList,
    handleOnChange,
    clearSearch,
    searchValue,
    showSearch,
  } = BranchFollowGroupsContextImport();

  const [branchName, setBranchName] = useState<string>("");
  const [branchLogo, setBranchLogo] = useState<string>("");
  const [groups, setGroups] = useState<Array<FollowGroupsList> | null>(null);

  const initData = () => {
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    const branchLogoSession: string = CacheStorage.getValue(
      StorageKeys.branch_logo
    );

    if (
      UtilityHelper.isEmpty(branchNameSession) ||
      UtilityHelper.isEmpty(branchLogoSession)
    ) {
      getBranchDetail();
    } else {
      setBranchName(branchNameSession);
      setBranchLogo(branchLogoSession);
    }
  };

  useEffect(() => {
    initData();
    getGroupsListAPI();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setGroups(groupList);
  }, [groupList]);

  useEffect(() => {
    if (branchDetail != null) {
      setBranchName(branchDetail?.title!);
      setBranchLogo(branchDetail?.branch_logo_url!);
    }
  }, [branchDetail]);

  return (
    <Div className={`${!isModal && "pt-lg-4 pb-5  h-100"}`}>
      {UtilityHelper.isNotEmpty(branchName) && !isModal && showSearch && (
        <>
          <SearchInput
            name="search-follow-groups"
            placeHolder="search"
            handleOnChange={handleOnChange}
            onClickSuffix={clearSearch}
            value={searchValue}
            autoFocus={true}
            listLogic={true}
          />
        </>
      )}

      <>
        {UtilityHelper.isEmpty(branchName) ? (
          <Center className="h-100">{Loader.normal()}</Center>
        ) : (
          !isModal && (
            <>
              <BranchLogoName
                name={branchName}
                logo={branchLogo}
                type={type}
                size={type === 2 ? 180 : 90}
              />
              <SpacingHeight value={40} />
            </>
          )
        )}
      </>

      {UtilityHelper.isNotEmpty(branchName) && (
        <BranchFollowGroupsList type={type} groupList={groups} />
      )}
    </Div>
  );
};
